import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone } from 'lucide-react';

const Col = ({ title, children }) => (
  <div>
    <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">{title}</h4>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const L = ({ href = '#', children }) => (
  <li>
    <a href={href} className="text-neutral-400 hover:text-[#22c55e] text-sm transition-colors">{children}</a>
  </li>
);

export default function Footer() {
  return (
    <footer className="bg-black text-white pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 pb-14 border-b border-neutral-900">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-11 h-11 rounded-xl bg-[#22c55e] flex items-center justify-center">
                <div className="w-8 h-8 rounded-lg bg-black flex items-center justify-center">
                  <span className="text-[#22c55e] font-black text-lg">X</span>
                </div>
              </div>
              <div>
                <div className="font-black text-xl">Xxpand<span className="text-[#22c55e]">.</span>io</div>
              </div>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6 max-w-md">
              Born from the experience of 80+ global businesses, Xxpand.io offers a comprehensive automation solution to help you streamline, automate, and grow.
            </p>
            <div className="flex items-center gap-3">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-lg bg-neutral-900 hover:bg-[#22c55e] hover:text-black text-neutral-400 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <Col title="Quick Links">
            <L>About Us</L>
            <L>Blogs</L>
            <L>Contact Us</L>
            <L>Pricing</L>
            <L>FAQs</L>
          </Col>

          <Col title="Best CRM For">
            <L>Hotels &amp; Resorts</L>
            <L>Real Estate</L>
            <L>Travel Agency</L>
            <L>Small Business</L>
            <L>Healthcare</L>
          </Col>

          <Col title="Get in Touch">
            <li>
              <a href="mailto:hello@xxpand.io" className="flex items-center gap-2 text-neutral-400 hover:text-[#22c55e] text-sm transition-colors">
                <Mail className="w-4 h-4" /> hello@xxpand.io
              </a>
            </li>
            <li>
              <a href="tel:+15551234567" className="flex items-center gap-2 text-neutral-400 hover:text-[#22c55e] text-sm transition-colors">
                <Phone className="w-4 h-4" /> +1 555 123 4567
              </a>
            </li>
          </Col>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-neutral-500">
          <div>&copy; 2026 Xxpand.io &mdash; All Rights Reserved</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#22c55e] transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-[#22c55e] transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
